import { render, staticRenderFns } from "./QrCodeGenerator.vue?vue&type=template&id=56b884be&scoped=true"
import script from "./QrCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QrCodeGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b884be",
  null
  
)

export default component.exports